export const BRAND = {
  cream: "#FFFDF5",
  ink: "#0F1116",
  orange: "#FF5722",
  pink: "#FF3B7A",
  lime: "#B8FF3B",
  sky: "#31B8FF",
  yellow: "#FFD93D",
};

// Per-class color blocking. Falls back to a rotating palette for new classes.
const PALETTE = [
  { bg: "#FF5722", fg: "#FFFDF5", tag: "#B8FF3B" }, // orange
  { bg: "#31B8FF", fg: "#0F1116", tag: "#FFD93D" }, // sky
  { bg: "#FF3B7A", fg: "#FFFDF5", tag: "#B8FF3B" }, // pink
  { bg: "#B8FF3B", fg: "#0F1116", tag: "#FF3B7A" }, // lime
  { bg: "#FFD93D", fg: "#0F1116", tag: "#FF5722" }, // yellow
];

const FIXED = {
  bible: PALETTE[0],
  belief: PALETTE[1],
  habits: PALETTE[2],
};

// Named, admin-selectable class colors. Stored on the class record (field
// `color`) in the backend so every connected frontend renders the same color.
export const CLASS_COLORS = {
  orange: { bg: "#FF5722", fg: "#FFFDF5", tag: "#B8FF3B" },
  sky: { bg: "#31B8FF", fg: "#0F1116", tag: "#FFD93D" },
  pink: { bg: "#FF3B7A", fg: "#FFFDF5", tag: "#B8FF3B" },
  lime: { bg: "#B8FF3B", fg: "#0F1116", tag: "#FF3B7A" },
  yellow: { bg: "#FFD93D", fg: "#0F1116", tag: "#FF5722" },
};

export function classAccent(slug, index = 0, color = null) {
  if (color && CLASS_COLORS[color]) return CLASS_COLORS[color];
  return FIXED[slug] || PALETTE[index % PALETTE.length];
}

export const ROLE_LABELS = {
  student: "Student",
  mentor: "Mentor",
  admin: "Admin",
  org_leader: "Organization Leader",
};
